import axios from 'axios';
import {
  REDEEM_CODE_URL,
  TOKEN_BALANCE_URL,
  TRANSACTION_HISTORY_URL,
} from '../../constants/urls';
import { getKeycloakToken } from './keycloak';

interface TokenBalanceResponse {
  amountLeft: number;
}

export interface TransactionHistoryItem {
  amount: number;
  status: string | null;
  source: string;
  dateCreated: string;
}

export interface TransactionHistoryResponse {
  content: TransactionHistoryItem[];
  page: number;
  pageSize: number;
  totalElements: number;
}

export const fetchTokenBalanceAsync = async (): Promise<number> => {
  const token = await getKeycloakToken();

  if (!token) {
    throw new Error('Missing Keycloak token.');
  }

  const response = await axios.get<TokenBalanceResponse>(TOKEN_BALANCE_URL, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data.amountLeft;
};

export const redeemCodeAsync = async (code: string): Promise<void> => {
  const token = await getKeycloakToken();

  if (!token) {
    throw new Error('Missing Keycloak token.');
  }

  await axios.post(
    REDEEM_CODE_URL,
    { code },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const fetchTransactionHistoryAsync = async (
  page: number,
  size: number,
): Promise<TransactionHistoryResponse> => {
  const token = await getKeycloakToken();

  if (!token) {
    throw new Error('Missing Keycloak token.');
  }

  const response = await axios.get<TransactionHistoryResponse>(
    TRANSACTION_HISTORY_URL,
    {
      params: { page, size },
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return response.data;
};
